// Combos, shoot & event add-ons, and the global "Opties" page config
export const EVENT_EXTRAS = [
  { name: "Audio Gastenboek", price: "vanaf €195", desc: "Laat een persoonlijke boodschap achter." },
  { name: "Confetti Kanonnen", price: "vanaf €50", desc: "Voor een spetterend moment." },
  { name: "Shimmer Wall", price: "vanaf €150", desc: "Prachtige achtergrond voor foto's." },
  { name: "Rode Loper & Afzetpaaltjes", price: "€75", desc: "VIP-uitstraling gegarandeerd." },
  { name: "LED Letters / Cijfers", price: "vanaf €65", desc: "Maak je decor compleet." },
  { name: "Luxe Gastenboek", price: "vanaf €45", desc: "Een blijvende herinnering." },
  { name: "Liefdelichtjes / LED", price: "vanaf €50", desc: "Warme sfeerverlichting." },
];

export const SHOOT_EXTRAS = [
  "Fine Art print of canvas (op aanvraag)",
  "Luxe fotoboek (op aanvraag)",
];

export const COMBOS = [
  {
    id: "wedding-combo",
    name: "Wedding Combo",
    price: "€1.845",
    savings: "Bespaar €150",
    icon: "Camera",
    color: "gold",
    items: ["Fotografie (6 uur)", "Magic Mirror (4 uur)", "Audio Gastenboek", "Onbeperkte prints", "Online galerij"],
    relatedSlugs: ["huwelijk", "magic-mirror", "audio-gastenboek"],
    highlight: true,
  },
  {
    id: "premium-party-combo",
    name: "Premium Party Combo",
    price: "€1.995",
    savings: "Bespaar €295",
    icon: "Sparkles",
    items: ["Fotografie (6 uur)", "Magic Mirror (6 uur)", "Audio Gastenboek", "Onbeperkte prints", "Online galerij"],
    extraOption: "Shimmer Wall backdrop optioneel bij te bestellen (+€75)",
    relatedSlugs: ["events", "magic-mirror", "audio-gastenboek"],
    highlight: true,
  },
  {
    id: "party-combo",
    name: "Party Combo",
    price: "€995",
    savings: "Bespaar €150",
    icon: "PartyPopper",
    items: ["Fotografie (4 uur)", "Magic Mirror (4 uur)", "Audio Gastenboek", "Onbeperkte prints", "Online galerij"],
    relatedSlugs: ["events", "magic-mirror", "audio-gastenboek"],
  },
  {
    id: "communie-combo",
    name: "Communie / Lentefeest Combo",
    price: "€345",
    savings: "Bespaar €45",
    icon: "Sparkles",
    items: ["Fotoshoot (2 uur)", "Bedankkaartjes (10 stuks)", "Online galerij"],
    extraOption: "Luxe fotoboek (20x20 cm) optioneel bij te bestellen",
    relatedSlugs: ["communie"],
  },
  {
    id: "baby-journey",
    name: "Baby Journey",
    price: "€575",
    savings: "Bespaar €100",
    icon: "Baby",
    items: ["Zwangerschap + Newborn + Cake Smash", "3 fotoshoots", "minimum 30 professioneel bewerkte foto's", "Online galerij"],
    extraOption: "Luxe fotoalbum (20x20 cm) optioneel bij te bestellen",
    extraBonus: "10% korting op extra producten",
    relatedSlugs: ["zwangerschap", "newborn"],
  },
  {
    id: "first-year",
    name: "First Year Collection",
    price: "€750",
    savings: "Bespaar €150",
    icon: "Heart",
    items: ["Zwangerschap + Newborn + 6 maanden + Cake Smash", "4 fotoshoots", "minimum 40 professioneel bewerkte foto's", "Online galerij"],
    extraOption: "Wanddecoratie & luxe fotoalbum optioneel bij te bestellen",
    extraBonus: "15% korting op extra producten",
    relatedSlugs: ["zwangerschap", "newborn"],
  },
  {
    id: "memories-for-life",
    name: "Memories for Life",
    price: "€895",
    savings: "Bespaar €250",
    icon: "Gem",
    items: ["Zwangerschap + Newborn + 6 maanden + Cake Smash + Gezinsshoot", "5 fotoshoots", "minimum 50 foto's", "Online galerij"],
    extraOption: "Wanddecoratie & luxe fotoalbum optioneel bij te bestellen",
    extraBonus: "20% korting op extra producten",
    relatedSlugs: ["zwangerschap", "newborn", "gezin"],
    highlight: true,
  },
  {
    id: "max-journey",
    name: "Max Journey",
    price: "€1.150",
    savings: "Bespaar €220",
    icon: "Crown",
    items: ["6 fotoshoots naar keuze", "Te spreiden over 1 jaar", "Bv. Gender Reveal + Zwangerschap + Newborn + Baby + Cake Smash + Gezin", "minimum 60 professioneel bewerkte foto's in hoge resolutie", "Persoonlijke online galerij"],
    extraOption: "Wanddecoratie & luxe fotoalbum optioneel bij te bestellen",
    extraBonus: "20% korting op extra producten",
    relatedSlugs: ["zwangerschap", "newborn", "gezin"],
    highlight: true,
  },
  {
    id: "hond-baas",
    name: "Hond & Baas Combo",
    price: "€225",
    icon: "PawPrint",
    items: ["1,5 uur fotoshoot", "minimum 10 professioneel bewerkte foto's", "Online galerij"],
    relatedSlugs: ["huisdieren"],
  },
  {
    id: "kat-baas",
    name: "Kat & Baas Combo",
    price: "€195",
    icon: "PawPrint",
    items: ["1 uur fotoshoot", "minimum 10 professioneel bewerkte foto's", "Online galerij"],
    relatedSlugs: ["huisdieren"],
  },
  {
    id: "paard-baas",
    name: "Paard & Baas Combo",
    price: "€275",
    icon: "PawPrint",
    items: ["1,5 uur fotoshoot", "minimum 15 professioneel bewerkte foto's", "Online galerij"],
    relatedSlugs: ["huisdieren"],
  },
  {
    id: "drie-maatjes",
    name: "3-Maatjes Combo",
    price: "€425",
    icon: "Gem",
    items: ["Hond + Kat + Paard", "2,5 uur fotoshoot", "minimum 20 professioneel bewerkte foto's", "Online galerij"],
    extraOption: "Luxe fotoboek (20x20 cm) optioneel bij te bestellen",
    relatedSlugs: ["huisdieren"],
  },
];

// Site-wide options / add-ons for the /opties page
export const OPTIES = {
  eyebrow: "Extra's & opties",
  title: "Opties voor elke shoot",
  intro:
    "Maak jouw fotoshoot compleet. Onderstaande opties zijn bij te bestellen bij elk pakket — van extra foto's tot luxe wanddecoratie en fotoboeken. Vraag gerust naar de mogelijkheden.",
  groups: [
    {
      title: "Foto's & bestanden",
      items: [
        { name: "Extra bewerkte foto", price: "€15 / stuk" },
        { name: "Alle digitale bestanden (onbewerkt)", price: "€75" },
        { name: "Snelle oplevering (binnen 5 werkdagen)", price: "€25" },
      ],
    },
    {
      title: "Prints & producten",
      items: [
        { name: "Fine art print", price: "vanaf €35" },
        { name: "Luxe fotoboek", price: "vanaf €95" },
        { name: "Canvas / wanddecoratie (dibond, plexi)", price: "vanaf €45" },
      ],
    },
    {
      title: "Beleving",
      items: [
        { name: "Confettikanon (roze of blauw)", price: "op aanvraag" },
        { name: "Magic Mirror Fotobooth", price: "op aanvraag" },
        { name: "Audio Gastenboek", price: "op aanvraag" },
      ],
    },
  ],
  note: "Alle prijzen zijn indicatief en optioneel bij te bestellen. Neem contact op voor een offerte op maat.",
};
